import { render, staticRenderFns } from "./button.vue?vue&type=template&id=6d01fb82&scoped=true&"
import script from "./button.js?vue&type=script&lang=js&"
export * from "./button.js?vue&type=script&lang=js&"
import style0 from "./button.scss?vue&type=style&index=0&id=6d01fb82&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d01fb82",
  null
  
)

export default component.exports